import React, { Component } from 'react';

import './Team.css';

import en from '../../../language/en/Team.json';
import es from '../../../language/es/Team.json';

import { team } from './Team.json'
import { Link } from 'react-router-dom';

class Team extends Component {
	constructor() {
		super();
		this.state = {
			config: {
				lang: {
					en: en,
					es: es
				}
			},
			team
		};
	}

	render() {
		const lang = this.state.config.lang;
		const selectedLanguage = (this.props.lang === 'en') ? lang.en : lang.es;

		const team = this.state.team.map((member, pos) => {
			return (
				<div className="col-sm-4" key={pos}>
					<div className="team-members">
						<div className="team-avatar">
							<img className="img-responsive" src={member.avatar} alt="" />
						</div>
						<div className="team-desc">
							<div className="team-details">
								<h4>{member.name}</h4>
								<span>{member.ocupation}</span>
							</div>
							<ul className="team-socials">
								{member.facebook && <li><a href={member.facebook}><i className="fa fa-facebook"></i></a></li>}
								{member.twitter && <li><a href={member.twitter}><i className="fa fa-twitter"></i></a></li>}
							</ul>
						</div>
					</div>
				</div>
			);
		});

		const firstPartTeam = team.filter((member, pos) => {
			return pos < this.state.team.length / 3;
		});
		//console.log('team1', firstPartTeam);

		const secondPartTeam = team.filter((member, pos) => {
			return pos >= this.state.team.length / 3 && pos < 2 * this.state.team.length / 3;
		});
		//console.log('team2', secondPartTeam);

		const thirdPartTeam = team.filter((member, pos) => {
			return pos >= 2 * this.state.team.length / 3;
		});
		//console.log('team3', thirdPartTeam);

		return (
			<section id="team">

				<div className="team-bg parallax">
					<div className="container">
						<div className="heading-light">
							<h2><strong>{selectedLanguage.sectionTitle}</strong></h2>
						</div>

						<div className="row">
							<div className="col-md-8">
								<div className="row">
									{firstPartTeam}
								</div>
								<div className="row">
									{secondPartTeam}
								</div>
								<div className="row">
									{thirdPartTeam}
								</div>
							</div>
							<div className="col-md-4">
								<div className="team-about">
									<h3>Se enriquece con la diversidad</h3>
									<p>Somos un equipo de trabajo integrado por especialistas de distintas disciplinas, que pueden aportar experiencias y miradas múltiples para un mismo problema.</p>
									<div className="margin-bottom-40"></div>
									<h3>Objetivos claros y bien definidos</h3>
									<p>Enfocado en suministrar información meteorológica y climática, confiable y oportuna sobre el estado y comportamiento futuro de la atmósfera.</p>
									<div className="margin-bottom-40"></div>
									<h3>Sentido de pertenencia</h3>
									<p>Nos preocupamos por generar una identidad común y lograr que los valores y la visión sean compartidos.</p>
									<div className="margin-bottom-40"></div>
									<h3>Se orienta a la solución de los problemas</h3>
									<p>Nos orientamos a la solución de los problemas, y no a la búsqueda de culpables.</p>
									<div className="margin-bottom-40"></div>
									<h3>Cuidada planificación</h3>
									<p>La planificación es esencial, puntualizamos los objetivos y diseñamos la estrategia que permitirá el logro del mismo.</p>
									<div className="margin-bottom-40"></div>
									<center style={{ marginTop: '30px' }}><Link to="/cmp/workers" className="btn-brd-white">Todos los Trabajadores</Link></center>
								</div>
							</div>
						</div>
					</div>
				</div>

			</section>
		);
	}
}

export default Team;